import React from "react";
import { useModalLicensesFormHook } from "./modal-licenses-form-hooks";

type ContextModalLicensesForm = ReturnType<typeof useModalLicensesFormHook>;
export const ModalLicensesFormContext =
  React.createContext<ContextModalLicensesForm | null>(null);

export function useContextModalLicensesForm() {
  const context = React.useContext(ModalLicensesFormContext);

  if (!context) {
    throw new Error(
      "useContextModalLicensesForm must be used within a ContextModalLicensesFormProvider",
    );
  }

  return context;
}
